import { Box, Typography, useTheme } from "@mui/material";
import {
  decrementQuantity,
  incrementQuantity,
  removeFromCart,
} from "../../actions/actions";
import { useDispatch, useSelector } from "react-redux";
import { getTheme } from "../../styles/theme";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  setDecrementQuantity,
  setIncrementQuantity,
  setRemoveFromCart,
} from "../../redux/actions/cartActions";
import { useTranslation } from "react-i18next";

export default function CartItems({ item, idx, serviceType }) {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const lightMode = useSelector((state) => state.mode.lightMode); // Redux state'inden lightMode değerini çekin
  const theme = useTheme();
  return (
    <Box
      key={idx}
      sx={{
        // boxShadow:
        //   "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
        borderBottom: `1px dashed ${lightMode ? "#e9ecee" : "#333e47"}`,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        padding: "2rem 1.25rem",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          background: "#ffffff",
          minWidth: "fit-content",
          maxHeight: "100px",
          position: "relative",
          overflow: "hidden",
          marginRight: "1.5rem",
          borderRadius: "1rem",
          boxShadow:
            "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100px",
            height: "100px",
            backgroundImage: `url(${item.image})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            filter: "blur(10px)",
            zIndex: 0,
          },
          "&::after": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100px",
            height: "100px",
            background: "rgba(0, 0, 0, .1)",
            zIndex: 0,
          },
        }}
      >
        <img
          style={{
            maxWidth: "100px",
            height: "100px",
            objectFit: "cover",
            objectPosition: "center",
            position: "relative",
            zIndex: 1,
          }}
          width={185}
          src={item.image}
        />
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{ fontWeight: "700" }}
          color={theme.palette.primary.main}
        >
          {item?.service_name}{" "}
          {item?.selectedSize ? `- ` + item?.selectedSize : ``}
        </Typography>
        <Typography textTransform={"capitalize"} sx={{ color: lightMode ? "#000000" : "#ffffff" }}>
          {t("price")}: {item.price}£
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "fit-content",
            marginTop: ".5rem",
            borderRadius: "1rem",
            overflow: "hidden",
            boxShadow:
              "0 0 2px 0 rgba(145 158 171 / 0.2),0 12px 24px -4px rgba(145 158 171 / 0.12)",
          }}
        >
          <Box
            onClick={() =>
              // dispatch(decrementQuantity(item.service_id))
              dispatch(
                setDecrementQuantity(
                  item.service_id,
                  serviceType === "products" ? "products" : "services"
                )
              )
            }
            sx={{
              padding: "1rem",
              backgroundColor: theme.palette.primary.light,
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            {item?.quantity == 1 ? (
              <DeleteIcon
                sx={{ color: "#ffffff" }}
                onClick={() =>
                  // dispatch(removeFromCart(item.service_id))
                  dispatch(
                    setRemoveFromCart(
                      item.service_id,
                      serviceType === "products" ? "products" : "services"
                    )
                  )
                }
              />
            ) : (
              `-`
            )}
          </Box>
          <Box
            sx={{
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: lightMode ? "#000000" : "#fff",
            }}
          >
            {item?.quantity}
          </Box>
          <Box
            onClick={() =>
              dispatch(
                setIncrementQuantity(
                  item.service_id,
                  serviceType === "products" ? "products" : "services"
                )
              )
            }
            sx={{
              padding: "1rem",
              backgroundColor: theme.palette.primary.light,
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            +
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
